import { useState } from "react"

/* =======================
   MOCK DATA (rút từ HTML)
======================= */
const PRODUCTS = [
    {
        skucode: "MEDX.R48872AX",
        slug: "amoxicilin-acid-clavulanic-875-125mg-r",
        name: "Amoxicilin/ Acid clavulanic 875mg/125mg Buymed (Hộp/2vỉ/7viên)",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/2025cf556cf249441f09faefa335050e",
        href: "/product/amoxicilin-acid-clavulanic-875-125mg-r",
        bg: "linear-gradient(rgb(245, 164, 71) 0%, rgb(245, 164, 71) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.9GX1FW96",
        slug: "loc-h-hit-thao-duoc-nhi-thien-duong-h-5gram",
        name: "Lốc Hũ Hít Thảo Dược Nhị Thiên Đường (Lốc/6hũ/5gram)",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/2025d16d6f88c2022f2a47f1e5c2124a",
        href: "/product/loc-h-hit-thao-duoc-nhi-thien-duong-h-5gram",
        bg: "linear-gradient(rgb(248, 174, 114) 0%, rgb(248, 174, 114) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.PURXJYJY",
        slug: "kem-boi-giam-dau-cobratoxan",
        name: "Kem bôi nọc rắn giảm đau cobratoxan đông dược 408",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/202553baa1070894f0a0f940683bb860",
        href: "/product/kem-boi-giam-dau-cobratoxan-dong-duoc-408",
        bg: "linear-gradient(rgb(248, 174, 114) 0%, rgb(248, 174, 114) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.R48872AX",
        slug: "amoxicilin-acid-clavulanic-875-125mg-r",
        name: "Amoxicilin/ Acid clavulanic 875mg/125mg Buymed (Hộp/2vỉ/7viên)",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/2025cf556cf249441f09faefa335050e",
        href: "/product/amoxicilin-acid-clavulanic-875-125mg-r",
        bg: "linear-gradient(rgb(245, 164, 71) 0%, rgb(245, 164, 71) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.9GX1FW96",
        slug: "loc-h-hit-thao-duoc-nhi-thien-duong-h-5gram",
        name: "Lốc Hũ Hít Thảo Dược Nhị Thiên Đường (Lốc/6hũ/5gram)",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/2025d16d6f88c2022f2a47f1e5c2124a",
        href: "/product/loc-h-hit-thao-duoc-nhi-thien-duong-h-5gram",
        bg: "linear-gradient(rgb(248, 174, 114) 0%, rgb(248, 174, 114) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.PURXJYJY",
        slug: "kem-boi-giam-dau-cobratoxan",
        name: "Kem bôi nọc rắn giảm đau cobratoxan đông dược 408",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/202553baa1070894f0a0f940683bb860",
        href: "/product/kem-boi-giam-dau-cobratoxan-dong-duoc-408",
        bg: "linear-gradient(rgb(248, 174, 114) 0%, rgb(248, 174, 114) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.R48872AX",
        slug: "amoxicilin-acid-clavulanic-875-125mg-r",
        name: "Amoxicilin/ Acid clavulanic 875mg/125mg Buymed (Hộp/2vỉ/7viên)",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/2025cf556cf249441f09faefa335050e",
        href: "/product/amoxicilin-acid-clavulanic-875-125mg-r",
        bg: "linear-gradient(rgb(245, 164, 71) 0%, rgb(245, 164, 71) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.9GX1FW96",
        slug: "loc-h-hit-thao-duoc-nhi-thien-duong-h-5gram",
        name: "Lốc Hũ Hít Thảo Dược Nhị Thiên Đường (Lốc/6hũ/5gram)",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/2025d16d6f88c2022f2a47f1e5c2124a",
        href: "/product/loc-h-hit-thao-duoc-nhi-thien-duong-h-5gram",
        bg: "linear-gradient(rgb(248, 174, 114) 0%, rgb(248, 174, 114) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.PURXJYJY",
        slug: "kem-boi-giam-dau-cobratoxan",
        name: "Kem bôi nọc rắn giảm đau cobratoxan đông dược 408",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/202553baa1070894f0a0f940683bb860",
        href: "/product/kem-boi-giam-dau-cobratoxan-dong-duoc-408",
        bg: "linear-gradient(rgb(248, 174, 114) 0%, rgb(248, 174, 114) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.R48872AX",
        slug: "amoxicilin-acid-clavulanic-875-125mg-r",
        name: "Amoxicilin/ Acid clavulanic 875mg/125mg Buymed (Hộp/2vỉ/7viên)",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/2025cf556cf249441f09faefa335050e",
        href: "/product/amoxicilin-acid-clavulanic-875-125mg-r",
        bg: "linear-gradient(rgb(245, 164, 71) 0%, rgb(245, 164, 71) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.9GX1FW96",
        slug: "loc-h-hit-thao-duoc-nhi-thien-duong-h-5gram",
        name: "Lốc Hũ Hít Thảo Dược Nhị Thiên Đường (Lốc/6hũ/5gram)",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/2025d16d6f88c2022f2a47f1e5c2124a",
        href: "/product/loc-h-hit-thao-duoc-nhi-thien-duong-h-5gram",
        bg: "linear-gradient(rgb(248, 174, 114) 0%, rgb(248, 174, 114) 50%, rgb(255,255,255) 100%)",
    },
    {
        skucode: "MEDX.PURXJYJY",
        slug: "kem-boi-giam-dau-cobratoxan",
        name: "Kem bôi nọc rắn giảm đau cobratoxan đông dược 408",
        image:
            "https://gcs.buymed.com/thuocsi-live/images/202553baa1070894f0a0f940683bb860",
        href: "/product/kem-boi-giam-dau-cobratoxan-dong-duoc-408",
        bg: "linear-gradient(rgb(248, 174, 114) 0%, rgb(248, 174, 114) 50%, rgb(255,255,255) 100%)",
    },
]

/* =======================
   COMPONENT
======================= */
export default function BlockProductHighProfit() {
    const [qtyMap, setQtyMap] = useState<Record<string, number>>(
        Object.fromEntries(PRODUCTS.map(p => [p.skucode, 0]))
    )

    const increase = (sku: string) => {
        setQtyMap(prev => ({
            ...prev,
            [sku]: prev[sku] + 1,
        }))
    }

    const decrease = (sku: string) => {
        setQtyMap(prev => ({
            ...prev,
            [sku]: Math.max(0, prev[sku] - 1),
        }))
    }

    const onChange = (sku: string, value: string) => {
        const num = Number(value)
        if (!isNaN(num) && num >= 0) {
            setQtyMap(prev => ({ ...prev, [sku]: num }))
        }
    }

    return (
        <div
            id="BLOCK_PRODUCT_HIGH_PROFIT"
            className="bg-white rounded-[10px] pt-4"
            style={{
                background:
                    "linear-gradient(rgb(248, 238, 234) 53%, rgb(248, 238, 234) 96%)",
            }}
        >
            {/* HEADER */}
            <div className="flex justify-between items-center px-4">
                <h2 className="font-bold text-gray-800 text-2xl flex items-center gap-2">
                    <img
                        src="https://cdn-gcs.thuocsi.vn/thuocsi-testing/internal/cms/2024614af5e9384c9d53c497f7254efdsalary_1.svg"
                        style={{ width: 36 }}
                    />
                    <span>Lợi nhuận cao</span>
                </h2>
            </div>

            {/* LIST */}
            <div className="flex flex-col gap-4 max-h-[700px] overflow-auto scrollbar-0 px-4 mt-2 pt-2 pb-4">
                {PRODUCTS.map(item => (
                    <div
                        key={item.skucode}
                        track-productitem=""
                        data-slug={item.slug}
                        data-href={item.href}
                        data-skucode={item.skucode}
                        data-blockcode="BLOCK_PRODUCT_HIGH_PROFIT"
                        className="flex flex-col w-full rounded-[10px] relative group border-[1px] transform transition-transform t-transition-transform duration-200
                        hover:scale-[1.05] hover:shadow-lg"
                        style={{ background: item.bg }}
                    >
                        <div className="flex px-4 py-2">
                            <div className="min-w-[87px]">
                                <a target="_blank" href={item.href} rel="noreferrer">
                                    <div className="relative w-[110px] h-[110px]">
                                        <img
                                            src={`${item.image}?width=150&quality=80`}
                                            className="w-full h-full object-contain"
                                        />
                                    </div>
                                </a>
                            </div>

                            <div className="flex justify-between flex-1 sm:!flex-row !flex-col ml-4">
                                <div className="ml-2 font-[ggsm]">
                                    <h2 className="text-[16px] text-black line-clamp-3">
                                        {item.name}
                                    </h2>
                                </div>

                                <div className="flex flex-col items-end h-full justify-between">
                                    {/* PRICE CANVAS */}
                                    <div className="styles_flex_no_wrap__1vvft MuiBox-root css-0">
                                        <div
                                            className="text-[22px] text-[#005c29] !leading-[30px]"
                                        >
                                            86.500 ₫
                                        </div>
                                    </div>

                                    {/* QUICK ORDER WRAPPER */}
                                    <div className="[&>div]:!bg-transparent">
                                        <div className="styles_maxWidth__qS6it highProfitQuickOrder">
                                            <div className="styles_container___oLk_ min-w-[160px] max-w-[160px] bg-white qty-control-viewed-wrapper">
                                                <div
                                                    className="styles_minusContainerNew__flGSc"
                                                    role="button"
                                                    onClick={() => decrease(item.skucode)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M7 12H17" stroke="#333333" stroke-width="2" stroke-linecap="round"></path></svg>
                                                </div>

                                                <div className="styles_groupInput__H1lLR qty-control-viewed-input-group">
                                                    <div className="styles_cartIconContainer__FoKUV">
                                                        <div className="styles_inputVisible__m_CzR">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="18"
                                                                height="18"
                                                                viewBox="0 0 18 18"
                                                                fill="none"
                                                            >
                                                                <path
                                                                    d="M14.3608 3.9375H4.00136L3.11622 2.35095C3.01687 2.17287 2.82892 2.0625 2.625 2.0625H1.5C1.18934 2.0625 0.9375 2.31434 0.9375 2.625C0.9375 2.93566 1.18934 3.1875 1.5 3.1875H2.2947L3.16822 4.75324L5.18278 9.21066L5.18484 9.21521L5.36228 9.60781L3.33965 11.7653C3.19422 11.9204 3.14869 12.1443 3.22199 12.3439C3.29529 12.5435 3.47488 12.6847 3.68614 12.7089L5.52974 12.9196C7.83575 13.1831 10.1643 13.1831 12.4703 12.9196L14.3139 12.7089C14.6225 12.6736 14.8442 12.3948 14.8089 12.0861C14.7736 11.7775 14.4948 11.5559 14.1861 11.5911L12.3425 11.8018C10.1214 12.0557 7.87861 12.0557 5.65749 11.8018L4.92585 11.7182L6.41038 10.1347C6.42474 10.1194 6.43808 10.1035 6.45039 10.0871L7.015 10.1605C7.8062 10.2635 8.60596 10.2837 9.40134 10.2208C11.2564 10.074 12.9758 9.19131 14.1761 7.7693L14.6097 7.25569C14.6242 7.23844 14.6377 7.22033 14.6501 7.20146L15.4581 5.97007C16.0309 5.09724 15.4048 3.9375 14.3608 3.9375Z"
                                                                    fill="#999999"
                                                                />
                                                                <path
                                                                    d="M4.875 13.875C4.25368 13.875 3.75 14.3787 3.75 15C3.75 15.6213 4.25368 16.125 4.875 16.125C5.49632 16.125 6 15.6213 6 15C6 14.3787 5.49632 13.875 4.875 13.875Z"
                                                                    fill="#999999"
                                                                />
                                                                <path
                                                                    d="M12 15C12 14.3787 12.5037 13.875 13.125 13.875C13.7463 13.875 14.25 14.3787 14.25 15C14.25 15.6213 13.7463 16.125 13.125 16.125C12.5037 16.125 12 15.6213 12 15Z"
                                                                    fill="#999999"
                                                                />
                                                            </svg>
                                                        </div>

                                                        <span className="styles_currentValue__b2ijJ">1</span>
                                                    </div>

                                                    <div className="MuiInput-root MuiInputBase-root MuiInputBase-colorPrimary styles_newCardInput__hecWu qty-control-viewed-input css-1f63zq5">
                                                        <input
                                                            type="number"
                                                            className="MuiInput-input MuiInputBase-input"
                                                            value={qtyMap[item.skucode]}
                                                            onChange={e =>
                                                                onChange(item.skucode, e.target.value)
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div
                                                    className="styles_addContainerNew__v_8_6"
                                                    role="button"
                                                    onClick={() => increase(item.skucode)}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M12 17V7" stroke="#005c29" stroke-width="2" stroke-linecap="round"></path><path d="M7 12L17 12" stroke="#005c29" stroke-width="2" stroke-linecap="round"></path></svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
